module.exports = __webpack_public_path__ + "prod/1.42.2/img/customer-4.5ba46857.jpg";